<script lang="ts">
  import { error, clearError } from "../services/errors";

  import Dialog from "./dialog.svelte";
</script>

{#if $error}
  <Dialog on:dismiss={clearError} title={$error.title} body={$error.message}>
    <button class="primary" type="button" on:click={clearError}>Dismiss</button>
  </Dialog>
{/if}
